import React, { useState, useContext, useMemo } from 'react'
import { Button, Dropdown, Menu, Icon, Tag, Input } from 'antd'
import styled from '@emotion/styled'
import ItemSelection from './ItemSelection'
import R from 'ramda'
import { connect } from 'react-redux'
import {
  getUnits,
  getUtilityNameMap,
  getUnitTypeCode,
  getUnitGroups,
  getUtilityUnitsMap,
  getEnvConfig,
  getPermitActions,
} from 'core/selectors'
import { UnitSelectionContext } from 'context'
import { hasAccesPermits } from 'core/utils'
import * as ScreenPermissions from 'core/EventActions'

const Top = styled.div`
  display: flex;
  align-items: center;
  padding-top: 16px;
  padding-bottom: 16px;
`

const Filler = styled.div`
  flex: 1 1 0px;
`

const fuzzyFilterPredicate = (item, text) => {
  return (
    text == null ||
    `${item.unitId} ${item.unitName} ${item.shortName} ${item.unitId} ${item.utility}`
      .toLowerCase()
      .includes(text.toLowerCase())
  )
}

export const UnitSelection = ({
  onConfirm,
  close,
  units,
  // groups = [],
  single,
  selectedUnits,
  // setSelectedUnits,
  hideTitle,
  title = 'Select Units',
  confirmText,
  utilityNameMap,
  multiUtility = true,
  disabled = false,
  unitTypeCode = {},
  unitGroups = [],
  visibleToggleGroup = true,
  visibleToggleUnitType = true,
  visibleUtility = true,
  placeholder = 'Filter for Units',
  nercGroup = [],
  // envConfig = {},
  actionPermits = [],
  ...props
}) => {
  const [unitData, setUnitData] = useState(units)
  const [selUtility, setSelUtility] = useState(['All'])
  const [unitType, setUnitType] = useState([])
  const [unitGroup, setUnitGroup] = useState([])
  const [selUnit, setSelUnit] = useState([...selectedUnits])
  const [selNercGroup, setSelNercGroup] = useState([])
  const confirm = units => {
    onConfirm(units)
  }

  const toggleUnits = units => {
    if (multiUtility) {
      const added = units.filter(u => !selUnit.includes(u))
      const removed = units.filter(u => selUnit.includes(u))
      if (!props.setCheckedItems)
        setSelUnit([...selUnit.filter(u => !removed.includes(u)), ...added])
      else
        props.setCheckedItems([
          ...selUnit.filter(u => !removed.includes(u)),
          ...added,
        ])
    } else {
      setSelUnit(units)
    }
  }

  const toggleUtility = ({ key }) => {
    // setUnitGroup([])
    // setUnitType([])

    let slUt =
      key === 'All'
        ? ['All']
        : selUtility.includes(key)
        ? selUtility.filter(t => t !== key && t !== 'All')
        : [...selUtility, key]

    slUt = slUt.length === 0 ? ['All'] : slUt.filter(t => t !== 'All')

    setSelUtility(slUt)

    const sunits =
      key === 'All' || slUt.includes('All')
        ? units
        : units.filter(u => slUt.includes(u.utility))
    setUnitData(sunits)
    const ids = sunits.map(s => s.unitId)

    if (key !== 'All') {
      // .filter(u => u.utility === key)
      setSelUnit(selUnit.filter(u => ids.includes(u.unitId)))
    }
  }

  const toggleUnitType = ({ key }) => {
    const ut = unitType.includes(key)
      ? unitType.filter(u => u !== key)
      : [...unitType, key]
    setUnitType(ut)
    toggleUnits(unitData.filter(f => f.id1 === key))
  }

  const toggleUnitGroup = ({ key }) => {
    const ugroup = unitGroup.includes(key)
      ? unitGroup.filter(u => u !== key)
      : [...unitGroup, key]

    const unitsIds = R.flatten(
      unitGroups.filter(f => f.unitGroup === key).map(u => u.units)
    )
    // .flat()

    setUnitGroup(ugroup)

    toggleUnits(unitData.filter(f => unitsIds.includes(f.unitId)))
  }

  const toggleUnitNercGroup = ({ key }) => {
    const ugroup = selNercGroup.includes(key)
      ? selNercGroup.filter(u => u !== key)
      : [...selNercGroup, key]

    const unitsIds = R.flatten(
      nercGroup.filter(f => ugroup.includes(f.groupName)).map(u => u.units)
    )
    // .flat()

    setSelNercGroup(ugroup)

    // toggleUnits(unitData.filter(f => unitsIds.includes(f.unitId)))

    setSelUnit(units.filter(u => unitsIds.includes(u.unitId)))
  }

  // const toggleGroup = group => {
  //   const groupUnits =
  //     groups[group] != null ? units.filter(u => groups[group].includes(u.unitId)) : []
  //   toggleUnits(groupUnits)
  // }

  const utilityFilterSearchBoxAccess = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.UNITMODEL_UTILITY_SEARCH],
        matchAny: true,
      }),
    [actionPermits]
  )

  const utilityOf = useMemo(
    _ =>
      R.uniq(
        (units || [])
          .map(u => ({ key: u.utility, name: utilityNameMap[u.utility] }))
          // .filter(a => !!a)
          .sort((a = {}, b = {}) =>
            (a.name || a.key || '')
              .toLowerCase()
              .localeCompare((b.name || b.key || '').toLowerCase())
          )
      ),
    [units, utilityNameMap]
  )

  const [filteredUtilities, setFilteredUtilities] = useState(utilityOf)

  const utilityFilter = keywords => {
    if (keywords && keywords.length !== 0) {
      const filteredUtility = utilityOf.filter(
        e =>
          e.key.toLowerCase().includes(keywords) ||
          e.name.toLowerCase().includes(keywords)
      )
      return setFilteredUtilities(filteredUtility)
    } else {
      setFilteredUtilities(utilityOf)
    }
  }

  const renderTopControls = ({
    checkAll,
    clearAll,
    fuzzyTextFilter,
    setFuzzyTextValue,
    inputRef,
  }) => {
    const filter = (
      <Input.Search
        // placeholder="Filter for Units"
        placeholder={placeholder}
        ref={inputRef}
        value={fuzzyTextFilter}
        onChange={e => setFuzzyTextValue(e.target.value)}
        style={{
          flex: '0 0 250px',
          marginRight: single ? '0px' : '16px',
        }}
      />
    )

    if (single)
      return (
        <Top hideTitle={hideTitle}>
          {!hideTitle && <div style={{ fontSize: '1.5em' }}>Select Unit</div>}
          <Filler />
          {filter}
        </Top>
      )

    const utilityMenus = (
      <>
        {utilityFilterSearchBoxAccess && (
          <Menu>
            <Menu.Item key="Search">
              <Input
                placeholder="Search"
                onChange={e => utilityFilter(e.target.value)}
                allowClear
                style={{ width: 300 }}
              />
            </Menu.Item>
          </Menu>
        )}
        <Menu
          onClick={toggleUtility}
          disabled={disabled}
          style={{ maxHeight: '600px', overflowY: 'auto' }}
        >
          <Menu.Item
            key="All"
            style={{
              backgroundColor: selUtility.includes('All')
                ? 'antiquewhite'
                : undefined,
            }}
          >
            All
          </Menu.Item>

          {filteredUtilities.map(utility => (
            <Menu.Item
              key={utility.key}
              style={{
                backgroundColor: selUtility.includes(utility.key)
                  ? 'antiquewhite'
                  : undefined,
                height: 25,
                display: 'grid',
                alignContent: 'center',
              }}
            >
              {utility.key}-{utility.name}
            </Menu.Item>
          ))}
        </Menu>
      </>
    )

    const unitTypeMenus = (
      <Menu onClick={toggleUnitType} disabled={disabled}>
        {Object.keys(unitTypeCode).map(k => (
          <Menu.Item key={k}>{unitTypeCode[k]}</Menu.Item>
        ))}
      </Menu>
    )

    const unitGroupsMenus = (
      <Menu onClick={toggleUnitGroup} disabled={disabled}>
        {unitGroups
          .map(k => k.unitGroup)
          .sort((a, b) => (a.toLowerCase() <= b.toLowerCase() ? -1 : 1))
          .map(k => (
            <Menu.Item key={k}>{k}</Menu.Item>
          ))}
      </Menu>
    )

    const unitNercGroupsMenus = (
      <Menu onClick={toggleUnitNercGroup} disabled={disabled}>
        {nercGroup
          .map(k => k.groupName)
          .sort((a, b) => (a.toLowerCase() <= b.toLowerCase() ? -1 : 1))
          .map(k => (
            <Menu.Item
              key={k}
              style={{
                backgroundColor: selNercGroup.includes(k)
                  ? 'antiquewhite'
                  : undefined,
              }}
            >
              {k}
            </Menu.Item>
          ))}
      </Menu>
    )

    const visibleNercGroup = nercGroup.length > 0
    return (
      <Top hideTitle={hideTitle}>
        {!hideTitle && <div style={{ fontSize: '1.5em' }}>{title}</div>}
        {!multiUtility && (
          <div style={{ fontSize: '1.5em' }}>Select Utility for Units</div>
        )}
        <Filler />
        {filter}
        {visibleNercGroup && (
          <Dropdown
            overlayStyle={{ maxHeight: '300px', overflowY: 'auto' }}
            overlay={unitNercGroupsMenus}
            disabled={!visibleNercGroup}
          >
            <Button style={{ marginLeft: '10px' }}>
              NERC Group <Icon type="down" />
            </Button>
          </Dropdown>
        )}
        {visibleToggleGroup && (
          <Dropdown
            overlayStyle={{ maxHeight: '300px', overflowY: 'auto' }}
            overlay={unitGroupsMenus}
            disabled={disabled || unitGroups.length <= 0}
          >
            <Button style={{ marginLeft: '10px' }}>
              Toggle Group <Icon type="down" />
            </Button>
          </Dropdown>
        )}
        {visibleToggleUnitType && (
          <Dropdown overlay={unitTypeMenus} disabled={disabled}>
            <Button style={{ marginLeft: '10px' }}>
              Toggle Unit Type <Icon type="down" />
            </Button>
          </Dropdown>
        )}
        {visibleUtility && (
          <Dropdown overlay={utilityMenus} disabled={disabled}>
            <Button style={{ marginLeft: '10px' }}>
              Utility <Icon type="down" />
            </Button>
          </Dropdown>
        )}
        {multiUtility && (
          <Button.Group style={{ marginLeft: '10px' }}>
            <Button onClick={checkAll} disabled={disabled}>
              Select All
            </Button>
            <Button
              onClick={_ => {
                setUnitGroup([])
                setUnitType([])
                clearAll()
                if (props.setCheckedItems) props.setCheckedItems([])
                else setSelUnit([])
              }}
              disabled={disabled}
            >
              Clear All
            </Button>
          </Button.Group>
        )}
      </Top>
    )
  }

  const itemToLabel = d => d.unit + '-' + d.unitName
  const itemToKey = d => d.unitId

  return (
    <ItemSelection
      renderTopControls={renderTopControls}
      itemToLabel={itemToLabel}
      itemToKey={itemToKey}
      onConfirm={confirm}
      close={close}
      itemWidth="260px"
      confirmText={confirmText}
      checked={selUnit}
      setCheckedItems={setSelUnit}
      data={unitData}
      single={single}
      fuzzyFilterPredicate={fuzzyFilterPredicate}
      multiUtility={multiUtility}
      disabled={disabled}
      {...props}
    />
  )
}

export const UnitSelectionBar = ({ units, ...props }) => {
  const {
    visibleUnitSelection,
    setVisibleUnitSelection,
    selectedUnits,
    setSelectedUnits,
  } = useContext(UnitSelectionContext)

  const showSelection = () => {
    setVisibleUnitSelection(!visibleUnitSelection)
  }

  const {
    limitedUnits,
    utilityNameMap,
    disabled,
    hideSelectedUnits = false,
  } = props
  // const { units, setSelectedUnits, selectedUnits, utilityNameMap } = props

  // selectedUnits: this.props.selectedUnits,
  // const [selectionVisible, setSelectionVisible] = useState(false)

  // const hideSelection = () => setSelectionVisible(false)
  // const showSelection = () => setSelectionVisible(true)

  const confirm = units => {
    setSelectedUnits(units)
    showSelection()
    !props.retrieveData && props.setData && props.setData(null)
    props.retrieveData && props.retrieveData({ selUnits: units })
  }

  const removeUnit = unit => {
    setSelectedUnits(selectedUnits.filter(u => u !== unit))
    props.setData && props.setData(null)
  }

  if (visibleUnitSelection)
    return (
      <div
        style={{
          paddingLeft: '16px',
          paddingRight: '16px',
          backgroundColor: 'white',
          marginBottom: '10px',
        }}
      >
        <UnitSelection
          onConfirm={confirm}
          units={limitedUnits || units}
          close={() => showSelection(false)}
          selectedUnits={selectedUnits}
          setSelectedUnits={setSelectedUnits}
          utilityNameMap={utilityNameMap}
          multiUtility={props.multiUtility}
          {...props}
        />
      </div>
    )

  return (
    <div
      style={{
        padding: '10px',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: 'white',
        marginBottom: '10px',
        ...props.style,
      }}
    >
      <Button
        disabled={disabled}
        style={{ marginRight: '5px' }}
        onClick={() => showSelection()}
      >
        Select Units
      </Button>
      {!hideSelectedUnits && (
        <div style={{ display: 'flex', overflow: 'hidden' }}>
          {selectedUnits.map(u => (
            <Tag
              closable={!disabled}
              color="blue"
              onClose={() => removeUnit(u)}
              // closable
              key={u.unitId}
            >
              {u.unitName}
            </Tag>
          ))}
        </div>
      )}
    </div>
  )
}

// const WrappedUnitSelectionBar = props => (
//   <CriteriaSelectionContext.Consumer>
//     {uProps => <UnitSelectionBar {...uProps} {...props} />}
//   </CriteriaSelectionContext.Consumer>
// )

// export default WrappedUnitSelectionBar

const mapStateToProps = state => ({
  units: getUnits(state),
  utilityNameMap: getUtilityNameMap(state),
  unitTypeCode: getUnitTypeCode(state),
  unitGroups: getUnitGroups(state),
  utlityUnitMap: getUtilityUnitsMap(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
})

// const mapDispatchToProps = dispatch => ({})

export default connect(mapStateToProps)(UnitSelectionBar)
